export const filterList = (filterList = null, action) => {
    if (action.type === "FILTER_LIST") {
        return action.payload;
    }
    return filterList;
};
